import React from "react";
import {Box, Tip, Text} from "grommet";
import DottedText from "./DottedText";
import StatusIcon from "./StatusIcon";

const InfoText = ({
    content, 
    children, 
    textProps, 
    contentProps={}, 
    plain=false,
    ...rest
}) => {
    if (plain) return (
        <Box direction="row" gap="xsmall" align="start">
            <Box pad={{vertical: 'xxsmall'}}>
                <StatusIcon type="info" size="xsmall" color="status-info-heavy" />
            </Box>
            <Text size="small" color="status-info-heavy">
                {content}
            </Text>
        </Box>
    );
    return (
        <Tip 
            content={(
                <Box width={{max: 'small'}} {...contentProps}>
                    {content}
                </Box>
            )} 
            {...rest}>
            {typeof children === "string" ? (
                <DottedText {...textProps}>
                    {children}
                </DottedText>
            ): children}
        </Tip>
    );
}

export default InfoText;